import { Component, OnInit, NgZone, } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { environment } from '../../../../../environments/environment';
import { AuthservicesService } from '../../../../services/authservices.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-create-daily-heralds',
  templateUrl: './create-daily-heralds.component.html',
  styleUrls: ['./create-daily-heralds.component.css']
})
export class CreateDailyHeraldsComponent implements OnInit {
  form: FormGroup;
  customCategory: FormArray;
  submitted = false
  errorMessage
  constructor(private authService: AuthservicesService, private fb: FormBuilder, private router: Router) { }
  ngOnInit(): void {
    this.errorMessage = environment.errorMessage
    this.form = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required],

    })
  }
  get f() {
    return this.form.controls;
  }

  onSubmit() {
    this.submitted = true;

    if (this.form.invalid) {
      this.authService.scrollToError();
      return;
    }
    this.authService.createPostcards(this.form.value).subscribe((res: any) => {
      this.authService.successMessage(res.message, 'success')
      this.router.navigate(['/post-cards'])

    },
      error => {
        this.authService.successMessage(error.error.message, 'error')
      })

  }

}
